import { z } from 'zod';
import { createApi } from '../core';
import { Enrolment } from '../types/enrolment';

const JoinClassroomRequestPayload = z.object({
  sessionId: z.string(),
  enrolment: Enrolment,
});
export type JoinClassroomRequestPayload = z.infer<typeof JoinClassroomRequestPayload>;

const JoinClassroomResponse = z.object({
  classroomLink: z.string(),
  studentToken: z.string(),
});

export const classroomApi = createApi.group(['classroom'], () => {
  return {
    joinClassroom: createApi.mutation({
      mutationFn: (params: JoinClassroomRequestPayload) => {
        try {
          return createApi.fetch({
            path: ['classroom', 'join'],
            method: 'POST',
            body: {
              sessionId: params.sessionId,
              studentDetails: {
                firstName: params.enrolment.student,
                lastName: params.enrolment.lastname,
                customerNumber: params.enrolment.customerNumber,
                contactDetails: {
                  sfAccoundId: params.enrolment.studentSfid,
                },
              },
            },
            validator: JoinClassroomResponse,
            basePath: 'portalAPI',
            sign: true,
          });
        } catch (error) {
          throw error;
        }
      },
    }),
  };
});
